/**
 * volume-spike-page.js
 *
 * Volume Spike strategy:
 *   Current:   today's volume > 2x the 200-day average
 *   Sustained: 3 or more days of 2x+ volume in the last 10 days
 *
 * Direction (long/short) is inferred from the 24h price change.
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchVolumeSpikeData } from '../services/server-api';
import { formatVolume } from '../utils/format-helpers';

const TF_LABELS = {
  current:   'Current spike (today > 2× avg)',
  sustained: 'Sustained spike (3+ of last 10 days)',
};

function renderDetails(entry) {
  const ratioStr = entry.volumeRatio != null ? `${entry.volumeRatio.toFixed(1)}×` : '—';
  const avgStr   = entry.volumeAvg   != null ? formatVolume(entry.volumeAvg)   : '—';
  const volStr   = entry.volumeLatest != null ? formatVolume(entry.volumeLatest) : '—';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Today's volume</span>
        <span className="mtf-ind-value bull">{volStr}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">200-day avg</span>
        <span className="mtf-ind-value zone">{avgStr}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Ratio</span>
        <span className="mtf-ind-value bull">{ratioStr} avg</span>
      </div>
      {entry.spikeCount != null && (
        <div className="mtf-ind-row">
          <span className="mtf-ind-label">Spike days</span>
          <span className="mtf-ind-value zone">{entry.spikeCount} of last 10</span>
        </div>
      )}
    </>
  );
}

function VolumeSpikePage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'Volume Spike',
        icon:       '⚡',
        subtitle:   'Volume > 2× 200-day average · direction inferred from 24h price change',
        fetchFn:    fetchVolumeSpikeData,
        timeframes: ['current', 'sustained'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default VolumeSpikePage;
